import React from "react";
import { DecimalField } from "cxa-form-field";
import { intlShape, injectIntl } from "react-intl";
import { Select } from "@cxagroup/casper";
import PropTypes from "prop-types";

const fieldMappings = {
  Decimal: DecimalField,
};

const CurrencyConverterField = ({
  name,
  items,
  error,
  required,
  handleCurrencyConverter,
  onChangeCurrencyCode,
  toCurrencyCode,
  selectDefaultValue,
  disabled,
  children = [],
  validate,
  label,
}) => {
  return (
    <div className="apl-claims__currency">
      {label && (
        <div className="field">
          <div className="field__label-wrapper">
            {required && (
              <span aria-label="Required" className="field__asterisk">
                *
              </span>
            )}
            <label className="field__label" htmlFor={name}>
              {label}
            </label>
          </div>
          <Select
            id={name}
            label={label}
            name={name}
            value={selectDefaultValue}
            required={required}
            readOnly={disabled}
            disabled={disabled}
            onChange={onChangeCurrencyCode}
            validate={validate}
            error={error}
            boxed
          >
            {items.map((item, { valueKey = "value", labelKey = "label" }) => (
              <option key={item[valueKey]} value={item[valueKey]}>
                {item[labelKey]}
              </option>
            ))}
          </Select>
        </div>
      )}

      {children.map(child =>
        React.createElement(fieldMappings[child.dataType], {
          id: child.name,
          key: child.name,
          name: `${child.name} (${toCurrencyCode})`,
          validate,
          readOnly: child.disabled,
          disabled: child.disabled,
          onChange: handleCurrencyConverter,
          className: "apl-claims__currency--amount",
          ...child,
        })
      )}
    </div>
  );
};

CurrencyConverterField.propTypes = {
  name: PropTypes.string,
  items: PropTypes.array,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  required: PropTypes.bool,
  handleCurrencyConverter: PropTypes.func,
  onChangeCurrencyCode: PropTypes.func,
  toCurrencyCode: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  selectDefaultValue: PropTypes.string,
  validate: PropTypes.array,
  intl: intlShape.isRequired,
};

export default injectIntl(CurrencyConverterField);



// WEBPACK FOOTER //
// ./components/claim/CurrencyConverterField.js